import {StorageWrapper} from './StorageWrapper'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables'
import {UIAppState} from './UIAppState'
import SFXDiceRoll1 from '@static/audio/compressed/sfx_dice_roll_1.mp3'
import SFXDiceRoll2 from '@static/audio/compressed/sfx_dice_roll_2.mp3'
import SFXDiceRoll3 from '@static/audio/compressed/sfx_dice_roll_3.mp3'
import SFXDiceRoll4 from '@static/audio/compressed/sfx_dice_roll_4.mp3'
import SFXYourTurn from '@static/audio/compressed/sfx_your_turn.mp3'
import SFXFirstReminder from '@static/audio/compressed/sfx_first_reminder.mp3'
import SFXRoadPlace from '@static/audio/compressed/sfx_road_place.mp3'
import SFXSettlementPlace from '@static/audio/compressed/sfx_settlement_place.mp3'
import SFXCityPlace from '@static/audio/compressed/sfx_city_place.mp3'
import SFXShipPlace from '@static/audio/compressed/sfx_ship_place.mp3'
import SFXShipMove from '@static/audio/compressed/sfx_ship_move.mp3'
import SFXMetropolisPlace from '@static/audio/compressed/sfx_metropolis_place.mp3'
import SFXCityWallPlace from '@static/audio/compressed/sfx_city_wall_place.mp3'
import SFXCityDestroy from '@static/audio/compressed/sfx_city_destroy.mp3'
import SFXCityImprovement from '@static/audio/compressed/sfx_city_improvement.mp3'
import SFXRobberPlace from '@static/audio/compressed/sfx_robber_place.mp3'
import SFXPiratePlace from '@static/audio/compressed/sfx_pirate_place.mp3'
import SFXVoteReminder from '@static/audio/compressed/sfx_vote_reminder.mp3'
import SFXOfferAcceptable from '@static/audio/compressed/sfx_offer_acceptable.mp3'
import SFXOfferNotAcceptable from '@static/audio/compressed/sfx_offer_not_acceptable.mp3'
import SFXOfferAccepted from '@static/audio/compressed/sfx_offer_accepted.mp3'
import SFXOfferRejected from '@static/audio/compressed/sfx_offer_rejected.mp3'
import SFXClockTick from '@static/audio/compressed/sfx_clock_tick.mp3'
import SFXKnightEquip from '@static/audio/compressed/sfx_knight_equip.mp3'
import SFXKnightPlace from '@static/audio/compressed/sfx_knight_place.mp3'
import SFXKnightUpgrade from '@static/audio/compressed/sfx_knight_upgrade.mp3'
import SFXDiscardBroadcast from '@static/audio/compressed/sfx_discard_broadcast.mp3'
import SFXDiscardNotification from '@static/audio/compressed/sfx_discard_notification.mp3'
import SFXClick from '@static/audio/compressed/sfx_click.mp3'
import SFXMessageNotification from '@static/audio/compressed/sfx_message_notification.mp3'
import SFXJoinRoom from '@static/audio/compressed/sfx_join_room.mp3'
import SFXLeaveRoom from '@static/audio/compressed/sfx_leave_room.mp3'
import SFXRoomSettingUpdated from '@static/audio/compressed/sfx_room_setting_updated.mp3'
import SFXRoomGetReady from '@static/audio/compressed/sfx_room_get_ready.mp3'
import SFXAchievementCkProgress from '@static/audio/compressed/sfx_achievement_ck_progress.mp3'
import SFXAchievementLargestArmy from '@static/audio/compressed/sfx_achievement_largest_army.mp3'
import SFXAchievementLongestRoad from '@static/audio/compressed/sfx_achievement_longest_road.mp3'
import SFXGameStarted from '@static/audio/compressed/sfx_game_started.mp3'
import SFXGameStartedGuitar from '@static/audio/compressed/sfx_game_started_guitar.mp3'
import SFXSettlementPhaseEnded from '@static/audio/compressed/sfx_settlement_phase_ended.mp3'
import SFXVictory from '@static/audio/compressed/sfx_victory.mp3'
import SFXReconnect from '@static/audio/compressed/sfx_reconnect.mp3'
import SFXDisconnect from '@static/audio/compressed/sfx_disconnect.mp3'
import SFXBeginnerHintActivated from '@static/audio/compressed/sfx_beginner_hint_activated.mp3'
import SFXDevCardBought from '@static/audio/compressed/sfx_devcard_bought.mp3'
import SFXDevCardUsed from '@static/audio/compressed/sfx_devcard_used.mp3'
import SFXDevCardMonopoly from '@static/audio/compressed/sfx_devcard_monopoly.mp3'
import {SoundURL} from '@colonist/types'

const AUDIO_DEFAULT_VOLUME = 0.5

export enum AudioType {
    DiceRoll1, DiceRoll2, DiceRoll3, DiceRoll4, YourTurn, FirstReminder,
    RoadPlace, SettlementPlace, CityPlace, ShipPlace, ShipMove, MetropolisPlace, CityWallPlace, CityDestroy, CityImprovement,
    RobberPlace, PiratePlace,
    LeaveRoom, JoinRoom, RoomSettingUpdated, RoomGetReady,
    ClockTick, MessageNotification, Click, Victory, VoteReminder, AchievementCKProgress, GameStarted, GameStartedGuitar, AchievementLargestArmy, AchievementLongestRoad, SettlementPhaseEnded,
    OfferAcceptable, OfferNotAcceptable, OfferAccepted, OfferRejected, Reconnect, Disconnect, KnightEquip, KnightPlace, KnightUpgrade, DiscardBroadcast, DiscardNotification,
    BeginnerHintActivated, DevelopmentCardBought, DevelopmentCardMonopoly, DevelopmentCardUsed
}

const ALLOWED_MOBILE_BACKGROUND_AUDIO: AudioType[] = [
    AudioType.YourTurn,
    AudioType.JoinRoom,
    AudioType.LeaveRoom,
    AudioType.GameStarted,
    AudioType.GameStartedGuitar,
]

const AUDIO_FILENAMES: Record<AudioType, SoundURL> = {
    [AudioType.DiceRoll1]: SFXDiceRoll1,
    [AudioType.DiceRoll2]: SFXDiceRoll2,
    [AudioType.DiceRoll3]: SFXDiceRoll3,
    [AudioType.DiceRoll4]: SFXDiceRoll4,
    [AudioType.YourTurn]: SFXYourTurn,
    [AudioType.FirstReminder]: SFXFirstReminder,
    [AudioType.RoadPlace]: SFXRoadPlace,
    [AudioType.SettlementPlace]: SFXSettlementPlace,
    [AudioType.CityPlace]: SFXCityPlace,
    [AudioType.ShipPlace]: SFXShipPlace,
    [AudioType.ShipMove]: SFXShipMove,
    [AudioType.MetropolisPlace]: SFXMetropolisPlace,
    [AudioType.CityWallPlace]: SFXCityWallPlace,
    [AudioType.CityDestroy]: SFXCityDestroy,
    [AudioType.CityImprovement]: SFXCityImprovement,
    [AudioType.RobberPlace]: SFXRobberPlace,
    [AudioType.PiratePlace]: SFXPiratePlace,
    [AudioType.VoteReminder]: SFXVoteReminder,
    [AudioType.OfferAcceptable]: SFXOfferAcceptable,
    [AudioType.OfferNotAcceptable]: SFXOfferNotAcceptable,
    [AudioType.OfferAccepted]: SFXOfferAccepted,
    [AudioType.OfferRejected]: SFXOfferRejected,
    [AudioType.ClockTick]: SFXClockTick,
    [AudioType.KnightEquip]: SFXKnightEquip,
    [AudioType.KnightPlace]: SFXKnightPlace,
    [AudioType.KnightUpgrade]: SFXKnightUpgrade,
    [AudioType.DiscardBroadcast]: SFXDiscardBroadcast,
    [AudioType.DiscardNotification]: SFXDiscardNotification,
    [AudioType.Click]: SFXClick,
    [AudioType.MessageNotification]: SFXMessageNotification,
    [AudioType.JoinRoom]: SFXJoinRoom,
    [AudioType.LeaveRoom]: SFXLeaveRoom,
    [AudioType.RoomSettingUpdated]: SFXRoomSettingUpdated,
    [AudioType.RoomGetReady]: SFXRoomGetReady,
    [AudioType.AchievementCKProgress]: SFXAchievementCkProgress,
    [AudioType.AchievementLargestArmy]: SFXAchievementLargestArmy,
    [AudioType.AchievementLongestRoad]: SFXAchievementLongestRoad,
    [AudioType.GameStarted]: SFXGameStarted,
    [AudioType.GameStartedGuitar]: SFXGameStartedGuitar,
    [AudioType.SettlementPhaseEnded]: SFXSettlementPhaseEnded,
    [AudioType.Victory]: SFXVictory,
    [AudioType.Reconnect]: SFXReconnect,
    [AudioType.Disconnect]: SFXDisconnect,
    [AudioType.BeginnerHintActivated]: SFXBeginnerHintActivated,
    [AudioType.DevelopmentCardBought]: SFXDevCardBought,
    [AudioType.DevelopmentCardUsed]: SFXDevCardUsed,
    [AudioType.DevelopmentCardMonopoly]: SFXDevCardMonopoly,
}

class AudioManager {
    private readonly context: AudioContext
    private readonly buffers: Map<AudioType, AudioBuffer>
    private readonly masterGain: GainNode

    get isMuted(): boolean {
        return this.masterGain.gain.value === 0
    }

    constructor() {
        this.context = new AudioContext()
        this.buffers = new Map()

        this.masterGain = this.context.createGain()
        this.masterGain.connect(this.context.destination)
        this.masterGain.gain.value = StorageWrapper.getMasterVolume(AUDIO_DEFAULT_VOLUME)

        this.unlockAudioWithFirstUserInteraction()
    }

    private async load(type: AudioType, url: SoundURL) {
        if(this.buffers.has(type)) return

        const response = await fetch(url)
        if(!response.ok) {
            // eslint-disable-next-line no-console
            console.error(`Failed to load sound: ${url}`)
            return
        }

        const arrayBuffer = await response.arrayBuffer()
        const buffer = await this.context.decodeAudioData(arrayBuffer)
        this.buffers.set(type, buffer)
    }

    async loadAll() {
        if(window['Cypress'] != undefined) return

        const audioTypes = Object.values(AudioType).filter((value) => typeof value === 'number') as AudioType[]
        const promises = audioTypes.map((type) => this.load(type, AUDIO_FILENAMES[type]))

        await Promise.all(promises)

        const isMobileApp = UIUtilsEjsVariables.isUserOnMobileApp || UIUtilsEjsVariables.isUserOnDiscordMobile
        if(isMobileApp) this.handleAudioContextLossForIOSMobile()
    }

    play(audio: AudioType, relativeVolume: number = 1, pitch: number = 1) {
        if(!AudioManager.canPlayAudioInMobile(audio)) return
        if(this.isMuted) return

        const buffer = this.buffers.get(audio)
        if(!buffer) return

        void this.resumeAudioContext()

        const source = this.context.createBufferSource()
        source.buffer = buffer
        source.playbackRate.value = pitch

        const gainNode = this.context.createGain()
        gainNode.gain.value = relativeVolume
        gainNode.connect(this.masterGain)
        source.connect(gainNode)
        source.start(0)
    }

    setMasterVolume(volume: number) {
        this.masterGain.gain.value = volume
        StorageWrapper.setMasterVolume(volume)
    }

    toggleMute() {
        const volume = this.isMuted ? AUDIO_DEFAULT_VOLUME : 0
        this.setMasterVolume(volume)
    }

    private async resumeAudioContext() {
        if(this.context.state !== 'suspended') return

        await this.context.resume()
    }

    private unlockAudioWithFirstUserInteraction() {
        const unlockAudio = async() => {
            await this.resumeAudioContext()

            document.removeEventListener('click', unlockAudio)
        }

        document.addEventListener('click', unlockAudio, {once: true})
    }

    private handleAudioContextLossForIOSMobile() {
        document.addEventListener('visibilitychange', () => {
            if(document.visibilityState !== 'hidden') {
                setTimeout(async() => {
                    await this.context.resume()
                }, 500)
            }
        }, false)
    }

    private static canPlayAudioInMobile(audio: AudioType) {
        if(!UIUtilsEjsVariables.isUserOnMobileApp) return true
        if(UIAppState.isAppRunningOnBackground == false) return true
        if(ALLOWED_MOBILE_BACKGROUND_AUDIO.includes(audio)) return true

        return false
    }
}

export const audioManager = new AudioManager()

/**
 * @deprecated
 * Use `audioManager` instead
 */
export module Sound {
    /**
     * @deprecated
     * Use `AUDIO_DEFAULT_VOLUME` instead
     */
    export const DEFAULT_VOLUME = AUDIO_DEFAULT_VOLUME

    /**
     * @deprecated
     * Use AudioType instead
     */
    export import SoundType = AudioType

    /**
     * @deprecated
     * Use `audioManager.loadAll()` instead
     */
    export function loadSounds() {
        void audioManager.loadAll()
    }

    /**
     * @deprecated
     * Use `audioManager.setMasterVolume()` instead
     */
    export function setMasterVolume(newVolume: number) {
        audioManager.setMasterVolume(newVolume)
    }

    /**
     * @deprecated
     * Use `audioManager.play()` instead
     */
    export function playSound(sound: SoundType, relativeVolume?: number | undefined, pitch?: number | undefined) {
        audioManager.play(sound, relativeVolume, pitch)
    }
}
